/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
   export class EsriQueryResult {
       public displayFieldName: string;
       public spatialReference: EsriSpatialReference;
       public geometryType: string;
       public features: Feature[];
    } 

    export class EsriSpatialReference {
       public wkid:number; 
   }

    export class Feature {
        geometry: any;
        attributes:any;
    }
}